export const DAILY_REPORTS_SET = 'DAILY_REPORTS_SET';
export const DAILY_REPORTS_UPDATE = 'DAILY_REPORTS_UPDATE';
export const SHOW_ADD_DAILY_REPORT_SET = 'SHOW_ADD_DAILY_REPORT_SET';
export const SET_CONTRIBUTORS = 'SET_CONTRIBUTORS';
export const SET_CURRENT_DAILY_REPORT = 'SET_CURRENT_DAILY_REPORT';
export const ADD_DAILY_REPORT_SUCCESS = 'ADD_DAILY_REPORT_SUCCESS';
export const SET_ACTIVE_CONTRIBUTOR = 'SET_ACTIVE_CONTRIBUTOR';
export const SET_ACTIVE_ENTRIES_ID = 'SET_ACTIVE_ENTRIES_ID';
export const LOAD_PRESET_TASKS = 'LOAD_PRESET_TASKS';
export const SET_PRESET_TASKS = 'SET_PRESET_TASKS';
export const INITIALIZE_TRADE_FORM = 'INITIALIZE_TRADE_FORM';
export const UPDATE_TRADE_FORM = 'UPDATE_TRADE_FORM';
export const CHANGE_AMOUNT_OF_TECHNICIANS = 'CHANGE_AMOUNT_OF_TECHNICIANS';
export const HANDLE_WORKED_FORM = 'HANDLE_WORKED_FORM';
export const HANDLE_WORKED_TO = 'HANDLE_WORKED_TO';
export const HANDLE_HOURS_AMOUNT = 'HANDLE_HOURS_AMOUNT';
export const HANDLE_ATTRIBUTE_CHANGE = 'HANDLE_ATTRIBUTE_CHANGE';
export const SET_IMAGES = 'SET_IMAGES';
export const SET_REVIEW_FORM = 'SET_REVIEW_FORM';
export const SET_REPORT_SUBMITTED = 'SET_REPORT_SUBMITTED';
export const CLEAR_FORM = 'CLEAR_FORM';
export const SET_DAILY_REPORT_LOG_PDF = 'SET_DAILY_REPORT_LOG_PDF';
export const SET_DAILY_REPORT_LOG_PDF_VIEWER =
  'SET_DAILY_REPORT_LOG_PDF_VIEWER';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const SET_REPORTS_IDS = 'SET_REPORTS_IDS';
export const DELETE_DAILY_REPORT = 'DELETE_DAILY_REPORT';
export const SET_REPORT_PDF = 'SET_REPORT_PDF';
export const SET_REPORT_PDF_VIEWER = 'SET_REPORT_PDF_VIEWER';
export const SET_REPORT_DATE = 'SET_REPORT_DATE';
export const SET_REPORT_EXTRA_INPUTS = 'SET_REPORT_EXTRA_INPUTS';
export const SET_REPORT_EXTRA_INPUT = 'SET_REPORT_EXTRA_INPUT';
export const SET_REPORT_OPEN_ITEM = 'SET_REPORT_OPEN_ITEM';
export const SET_REPORT_OPEN_ITEM_VALUE = 'SET_REPORT_OPEN_ITEM_VALUE';
export const SET_GENERAL_CONTACTOR_NAME = 'SET_GENERAL_CONTACTOR_NAME';
export const SET_MEMBER_FORM = 'SET_MEMBER_FORM';
export const SET_SUPERVISOR_TASKS = 'SET_SUPERVISOR_TASKS';
export const SET_MEMBERS = 'SET_MEMBERS';
export const SET_DELETED_MEMBERS = 'SET_DELETED_MEMBERS';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_REPORTS_TOTAL = 'SET_REPORTS_TOTAL';
export const SET_REPORTS_PAGE_SIZE = 'SET_REPORTS_PAGE_SIZE';
export const SET_GCX_IMAGES = 'SET_GCX_IMAGES';
export const SET_GCX_DELETED_IMAGES = 'SET_GCX_DELETED_IMAGES';
export const SET_DELIVERY = 'SET_DELIVERY';
export const DELETE_DELIVERY = 'DELETE_DELIVERY';
export const ADD_EXTRA_INPUT = 'ADD_EXTRA_INPUT';
export const REMOVE_DELIVERIES_EXTRA_INPUT = 'REMOVE_DELIVERIES_EXTRA_INPUT';
export const SET_DAILY_REPORT_TAB = 'SET_DAILY_REPORT_TAB';
export const SUB_DAILY_REPORTS_COUNT_SUCCESS =
  'SUB_DAILY_REPORTS_COUNT_SUCCESS';
export const SUB_DAILY_REPORTS_COUNT_INIT = 'SUB_DAILY_REPORTS_COUNT_INIT';
export const HANDLE_ATTRIBUTE_CHANGE_FOR_SUB =
  'HANDLE_ATTRIBUTE_CHANGE_FOR_SUB';
export const HANDLE_HOURS_AMOUNT_MORE_INFO = 'HANDLE_HOURS_AMOUNT_MORE_INFO';
export const HANDLE_DATE_MORE_INFO = 'HANDLE_DATE_MORE_INFO';
export const HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION =
  'HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION';
export const ADDED_DELETED_TECHNICIANS = 'ADDED_DELETED_TECHNICIANS';
export const FIELD_WORK_ORDERS_SET = 'FIELD_WORK_ORDERS_SET';
export const SET_SHOW_FIELD_WORK_ORDER = 'SET_SHOW_FIELD_WORK_ORDER';
export const FIELD_WORK_ORDER_SET = 'FIELD_WORK_ORDER_SET';
export const FIELD_WORK_ORDER_FORM_INIT = 'FIELD_WORK_ORDER_FORM_INIT';
export const FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET =
  'FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET';
export const SET_FIELD_WORK_ORDER_EDIT = 'SET_FIELD_WORK_ORDER_EDIT';
export const UPDATE_FIELD_WORK_ORDER_SUCCESS =
  'UPDATE_FIELD_WORK_ORDER_SUCCESS';
export const SET_SHOW_FIELD_WORK_ORDER_ERROR =
  'SET_SHOW_FIELD_WORK_ORDER_ERROR';
export const SET_DAILY_REPORT_ADD_FLOOR = 'SET_DAILY_REPORT_ADD_FLOOR';
export const DUPLICATE_DAILY_REPORT_SUCCESS = 'DUPLICATE_DAILY_REPORT_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/store/action-types.js